<template>
	<el-drawer
	  ref="drawer"
	  :with-header="false"
	  size="40%"
	  :visible.sync="dialogTableVisible"
	  direction="rtl"
	  v-loading="loading"
	  custom-class="demo-drawer"
	>
	    <el-form ref="dataForm" :model="dataForm" label-position="left" label-width="70px" style="width: 100%; padding:10px; height: 100vh;overflow-y: scroll;">
	       <el-tabs tab-position="top" style="height: 250px;">
			   <el-tab-pane tabIndex=-1 label="订单详情">
				    <div class="title">订单信息：</div>
					<div class="cons" style="display: flex;align-items: center;">
						状态：
						<span :style="{color:dataForm.status==0?'red':''}">
							{{dataForm.statusname}}
						</span>
						
						<el-button @click="zhifud()" type="success" size="mini" style="margin-left: auto;" v-if="dataForm.status==0 && types==0">
							立即支付
						</el-button>
					</div>
					<!--支付二维码-->
					<zhifu ref="zhifudata" @successpay="user_yunxing_detail()"></zhifu>
					
					<div class="cons" v-if="dataForm.status==1 || dataForm.status==2 || dataForm.status==3">
						支付时间：{{dataForm.payTime}}
					</div>
					<div class="cons">
					   环境名称：{{dataForm.huanjingname}}
					</div>
					<div class="cons">
						订单号：
						<span style="color: #ff4500;">
							{{dataForm.orderno}}
						</span>
					</div>
					<div class="cons">
						类型：{{dataForm.types==1?'个人':'组织'}}
					</div>
					<div class="cons" v-if="dataForm.yunxingtype==1">
						数据库算力价格：
						¥<span style="color: #ff4500;">{{dataForm.mysqlsuanli}}</span>元
					</div>
					<div class="cons" v-if="dataForm.yunxingtype==1">
						应用服务器算力价格：
						¥<span style="color: #ff4500;">{{dataForm.serversuanli}}</span>元
					</div>
					<div class="cons">
						总价：
						¥<span style="color: #ff4500;">{{dataForm.money}}</span>元
					</div>
					
					<div v-if="dataForm.yunxingtype==1">
						<div class="title" style="margin-top: 20px;">运行资源：</div>
						<el-table
						  :data="dataForm.yunxings"
						  border
						  fit
						  highlight-current-row
						  style="width: 100%;"
						  :header-cell-style="{background:'#f5f5f5'}"
						>
						  <el-table-column label="CPU" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.suanli}}核</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="用途" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.yongtu==1?'数据库':'应用服务器'}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="内网ip" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.ip}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="外网ip" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.wip}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="管理员id" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.adminid}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="管理员密码" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.password}}</span>
						    </template>
						  </el-table-column>
						</el-table>
					</div>
					
					<div v-if="dataForm.yunxingtype==2">
						<div class="title" style="margin-top: 20px;">运行节点：</div>
						<el-table
						  :data="dataForm.shangxians"
						  border
						  fit
						  highlight-current-row
						  style="width: 100%;"
						  :header-cell-style="{background:'#f5f5f5'}"
						>
						  <el-table-column label="ip" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.ip}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="运行保障级别" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.title}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="服务价格" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.money}}</span>
						    </template>
						  </el-table-column>
						</el-table>
					</div>
					
				</el-tab-pane>
		   </el-tabs>
		</el-form>
    </el-drawer>
</template>

<script>
	import { user_yunxing_detail } from "@/api/huanjing"
	import zhifu from "../zhifu.vue"
	export default {
		components:{
			zhifu
		},
		data(){
			return{
				id:'',
				loading:false,
				dialogTableVisible:false,
				dataForm:{
					
				},
				types:0
			}
		},
		watch:{
			dialogTableVisible(e){
				if(e==false){
					this.dataForm = {}
					this.types = 0
					this.$emit("chenggong");
				}
			},
		},
		methods:{
			zhifud(){
				this.$refs.zhifudata.show(this.dataForm.id,this.dataForm.money,2)
			},
			user_yunxing_detail(){
				this.loading = true
				user_yunxing_detail({
					id:this.id
				}).then(res=>{
					this.loading = false
					console.log("运行资源申请",res.data);
					this.dataForm = res.data
				}).catch(()=>{
					this.loading = false
				})
			},
			handlecreate(id,types){
				this.dialogTableVisible = true
				this.id = id
				this.types = types?types:0
				this.user_yunxing_detail();
			},
		},
	}
</script>

<style lang="scss">
   .v-modal{
		z-index: 999!important;
	}
	.title{
		color: #ff4500;
		font-size: 16px;
		padding-bottom: 20px;
		font-weight: bold;
	}
	.cons{
		font-size: 14px;
		color: #333;
		padding-top: 10px;
		padding-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/components/yunxingdetail.vue